/* Collection filter/sort bar (nama-collection-filters.liquid).
   Popovers, all-filters drawer, sort navigation, price form.
   Size options append the in-stock filter (variant-level combination:
   size M + available = pieces with M in stock). */
(function () {
  var root = document.querySelector('[data-ncf]');
  if (!root) return;

  function closeAllPanels(except) {
    root.querySelectorAll('[data-ncf-panel]').forEach(function (p) {
      if (p !== except) p.hidden = true;
    });
    root.querySelectorAll('[data-ncf-toggle]').forEach(function (b) {
      var panel = b.parentElement.querySelector('[data-ncf-panel]');
      b.classList.toggle('is-open', !!panel && !panel.hidden);
    });
  }

  // Quick popovers (Size / Colour / Fabric / Sort)
  root.querySelectorAll('[data-ncf-quick]').forEach(function (q) {
    var btn = q.querySelector('[data-ncf-toggle]');
    var panel = q.querySelector('[data-ncf-panel]');
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = panel.hidden;
      closeAllPanels();
      panel.hidden = !willOpen;
      btn.classList.toggle('is-open', willOpen);
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ncf-quick]')) closeAllPanels();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAllPanels(); closeDrawer(); }
  });

  // Size options: force the in-stock filter along with the size
  root.querySelectorAll('[data-ncf-instock]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var url = new URL(a.getAttribute('href'), location.origin);
      url.searchParams.set('filter.v.availability', '1');
      location.href = url.pathname + url.search;
    });
  });

  // Sort: keep current filters, swap sort_by
  root.querySelectorAll('[data-ncf-sort]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var url = new URL(location.href);
      url.searchParams.set('sort_by', a.getAttribute('data-ncf-sort'));
      url.searchParams.delete('page');
      location.href = url.pathname + url.search;
    });
  });

  // All-filters drawer
  var drawer = root.querySelector('[data-ncf-drawer]');
  function openDrawer() {
    drawer.classList.add('is-open');
    root.classList.add('drawer-open');
    document.body.classList.add('ncf-lock');
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    root.classList.remove('drawer-open');
    document.body.classList.remove('ncf-lock');
  }
  root.querySelectorAll('[data-ncf-drawer-open]').forEach(function (b) {
    b.addEventListener('click', openDrawer);
  });
  root.querySelectorAll('[data-ncf-drawer-close]').forEach(function (b) {
    b.addEventListener('click', closeDrawer);
  });

  // Drawer accordion groups
  root.querySelectorAll('[data-ncf-group-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var g = b.closest('[data-ncf-group]');
      if (g.hasAttribute('data-open')) g.removeAttribute('data-open');
      else g.setAttribute('data-open', '');
    });
  });

  // Price form: rebuild URL with current params + price range (in cents)
  root.querySelectorAll('[data-ncf-price]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var url = new URL(location.href);
      var minName = form.getAttribute('data-min-name');
      var maxName = form.getAttribute('data-max-name');
      var min = form.querySelector('[data-ncf-price-min]').value;
      var max = form.querySelector('[data-ncf-price-max]').value;
      url.searchParams.delete(minName);
      url.searchParams.delete(maxName);
      url.searchParams.delete('page');
      if (min !== '') url.searchParams.set(minName, min);
      if (max !== '') url.searchParams.set(maxName, max);
      location.href = url.pathname + url.search;
    });
  });

  // Portal the drawer + scrim to <body>: ancestors carry scroll-animation
  // transforms, which trap position:fixed and let the header paint over
  // the drawer. Listeners are already bound, so the move is safe.
  var scrimEl = root.querySelector('.ncf-scrim');
  if (scrimEl) document.body.appendChild(scrimEl);
  if (drawer) document.body.appendChild(drawer);
})();
